<template>
  <label
    class="form__field-label"
    :class="{ required: props.required, 'ml-0': !inline, disabled }"
    :for="props.name"
  >
    <template v-if="slots['label']">
      <slot name="label" />
    </template>

    <template v-else>
      {{ props.label }}
      <span
        v-if="props.required"
        class="required ml-ms-3"
      >
        *
      </span>
      <i
        v-if="props.labelTooltip"
        v-easy-tooltip="props.labelTooltip"
        class="icon icon-help-bubble ml-base-space"
      />
    </template>
  </label>
</template>

<script setup lang="ts">
import { useSlots } from "vue";
import { VueSlots } from "@/src/shared/types/slot";

interface Props {
  name: string;
  label?: string;
  required?: boolean;
  labelTooltip?: string;
  inline?: boolean;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  required: false,
  labelTooltip: "",
  label: undefined,
  inline: false,
  disabled: false,
});

const slots = useSlots() as VueSlots<["label"]>;
</script>
